import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { externalDataPropType } from './external-data-prop-type'

export const externalObjectDataPropType = PropTypes.shape({
    externalData: externalDataPropType,
    lastModified: PropTypes.number,
    lastModifiedChange: PropTypes.oneOf(['UPDATE', 'DELETE']),
    objectId: idPropType,
    pluginId: idPropType
})
